import { all, fork } from 'redux-saga/effects';
import { playSaga } from './play';
import { windowSaga } from './window';
import { videoSaga } from './video';
import { backgroundVideoSaga } from './backgroundVideo';
import { containerSaga } from './container';

export default function* playerSaga() {
  yield all([fork(videoSaga), fork(backgroundVideoSaga), fork(playSaga), fork(windowSaga), fork(containerSaga)]);
}
